import { render, staticRenderFns } from "./FormattedContent.vue?vue&type=template&id=17e59662&scoped=true"
import script from "./FormattedContent.vue?vue&type=script&lang=js"
export * from "./FormattedContent.vue?vue&type=script&lang=js"
import style0 from "./FormattedContent.vue?vue&type=style&index=0&id=17e59662&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e59662",
  null
  
)

export default component.exports